<template>
  <b-input-group-prepend v-if="prompts && prompts.length > 0">
    <b-button :id="'popover-'+action.id"><b>?</b></b-button>

    <b-popover ref="popover" :target="'popover-'+action.id" triggers="click" placement="top">
      <template v-slot:title>Vorschläge</template>
      <b-list-group flush>
        <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(value, key) in prompts" :key="key">

        <span class="mr-2">{{value}}</span>

        <b-button size="sm" variant="primary"><b-icon icon="chat-fill" font-scale="1.5" v-on:click.prevent="addUtterance(value)"></b-icon></b-button></b-list-group-item>
      </b-list-group>
    </b-popover>
  </b-input-group-prepend>

</template>

<script>
export default {
  name: 'Prompts',
  props: ['prompts', 'action'],
  computed: {

  },
  methods: {
    addUtterance (value) {
      if( value ) {
        this.$store.dispatch('addUtterance', { 'text': value});
        this.$refs.popover.$emit('close');
      }
    },
  }
}
</script>

<style scoped>

</style>
